import { render, staticRenderFns } from "./ProStrategy.vue?vue&type=template&id=78d5c0ef&"
import script from "./ProStrategy.vue?vue&type=script&lang=ts&"
export * from "./ProStrategy.vue?vue&type=script&lang=ts&"
import style0 from "./ProStrategy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports